<template>
  <Flex direction="column">
    <BaseAlert
      v-show="sendingIsDisabled"
      color="info"
      size="s"
      :text="$t('marketing.email.sections.company_in_trial_cant_schedule')"
    />
    <Flex
      v-show="!sendingIsDisabled"
      :class="$style.flex"
    >
      <BaseText>
        {{ $t('marketing.email.sections.schedule_send_checkbox') }}
      </BaseText>
      <BaseCheckbox
        v-model="hasDeliverySchedule"
        v-test="'toggleSchedule'"
      />
    </Flex>

    <Flex
      v-show="hasDeliverySchedule"
      :class="$style.dateTime"
      align="end"
    >
      <BaseDatePicker
        v-model="scheduleDate"
        :label="$t('marketing.email.sections.date_and_time')"
        onlyFutureDates
        v-test="'scheduleDate'"
      />
      <BaseTimePicker
        v-model="scheduleTime"
        :minValue="minTime"
        v-test="'scheduleTime'"
      />
    </Flex>
  </Flex>
</template>

<script lang="ts">
import { mapState, storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import dayjs from '@/dayjs';
import { combineDateTime } from '@/helpers/dates';
import { useCompanyStore } from '@/stores/company';
import { useMarketingStore } from '../../store';

export default defineComponent({
  setup() {
    const { deliverAt } = storeToRefs(useMarketingStore());
    return {
      deliverAt,
    };
  },
  computed: {
    ...mapState(useCompanyStore, ['allowedToMassSend']),
    hasDeliverySchedule: {
      get() {
        return useMarketingStore().hasDeliverySchedule;
      },
      set(newVal) {
        useMarketingStore().hasDeliverySchedule = newVal;
      },
    },
    selectedDateTime() {
      return this.deliverAt ? dayjs(this.deliverAt).tz() : this.minDateTime;
    },
    minDateTime() {
      return dayjs().add(5, 'minutes');
    },
    minTime() {
      if (this.selectedDateTime >= this.minDateTime) {
        return null;
      }

      return this.minDateTime.format('HH:mm');
    },
    sendingIsDisabled() {
      return !this.allowedToMassSend;
    },
    scheduleDate: {
      get() {
        return this.selectedDateTime.format('YYYY-MM-DD');
      },
      set(date) {
        this.deliverAt = combineDateTime(date, this.scheduleTime);
      },
    },
    scheduleTime: {
      get() {
        return this.selectedDateTime.format('HH:mm');
      },
      set(time) {
        this.deliverAt = combineDateTime(this.scheduleDate, time);
      },
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: $spacing;
}

.dateTime {
  display: flex;
  align-items: flex-end;
}
</style>
